module.exports = __webpack_public_path__ + "media/images/favicon/android-icon-36x36-57efa8b1caab31cd3250658d7b867f21.png";